import React from 'react'
import { BarChart, XAxis, YAxis, Bar } from 'recharts'

const customLabelClosure = ({fill, isVertical}) => (props) => {
  return (isVertical) ? (
    <text x={props.x + (props.width) + 3} y={(props.y + props.height + 9) - props.offset * 3} fill={fill}>{props.value}%</text>
        )
        : (
          <text x={props.x + (props.width / 4)} y={props.y - 1} fill={fill}>{props.value}%</text>
        )
}

const Chart = ({data = [], fill = '#8A8B8A', isVertical = false}) => {
  const barChartProps = {
    width: 170,
    height: 160,
    data,
    margin: {top: 5, right: 30, left: 20, bottom: 5}
  }
  const xAxisProps = {}
  const yAxisProps = {}
  if (isVertical) {
    barChartProps.layout = 'vertical'
    xAxisProps.hide = true
    xAxisProps.type = 'number'
    yAxisProps.type = 'category'
    yAxisProps.dataKey = 'name'
  } else {
    yAxisProps.hide = true
    yAxisProps.type = 'number'
    xAxisProps.type = 'category'
    xAxisProps.dataKey = 'name'
  }
  return (
    <BarChart {...barChartProps} >
      <XAxis {...xAxisProps} axisLine={false} tickLine={false} />
      <YAxis {...yAxisProps} axisLine={false} tickLine={false} />
      <Bar dataKey='val' fill={fill} label={customLabelClosure({fill, isVertical})} />
    </BarChart>
  )
}

export default Chart



// WEBPACK FOOTER //
// ../src/commons/components/SegmentsPopupContent/Chart.js